/**
 * Field — labelled input with inline red-border error display
 * Mirrors LoginForm/RegisterForm conventions.
 *
 * Props:
 *   label     {string}
 *   error     {string|undefined}
 *   id        {string}
 *   ...rest   passed to <input>
 */
const Field = ({ label, error, id, className = '', ...rest }) => {
  const inputId = id || rest.name;

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label
          htmlFor={inputId}
          className="text-sm font-montserrat font-medium text-[#4A4A4A]"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={[
          'w-full bg-[#F5F5F5] border rounded-xl py-3 px-4 font-montserrat text-sm text-[#4A4A4A]',
          'placeholder-gray-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#EAF4FB] transition-all',
          error ? 'border-red-500 focus:border-red-500' : 'border-transparent focus:border-[#17386E]',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      />
      {error && (
        <p className="text-xs text-red-600">{error}</p>
      )}
    </div>
  );
};

export default Field;
